export default function ThankYouModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground/40 backdrop-blur-sm px-4" onClick={onClose}>
      <div
        className="w-full max-w-sm bg-card rounded-3xl border border-border p-6 text-center space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-3xl">🎉</p>
        <p className="text-base font-medium text-foreground leading-relaxed">
          Thank you! Your review helps more people discover us and grows our community.
        </p>
        <button
          onClick={onClose}
          className="w-full py-3 bg-primary text-primary-foreground rounded-2xl font-semibold text-sm hover:bg-primary/90 active:scale-[0.98] transition-all"
        >
          Close
        </button>
      </div>
    </div>
  );
}